$ = jQuery;
export const scroll = {
  init: function () {
    $(".wp-block-group").addClass("reveal");
    $(".wp-block-heading").addClass("reveal");
    $(".wp-block-columns").addClass("reveal");
    $(".columns").addClass("reveal");
    $(".tax-list").addClass("reveal");
    $(".wp-block-buttons").addClass("reveal");
    $(".wp-block-column").find(".wp-block-heading").removeClass("reveal");
    $(".wp-block-group").find(".wp-block-columns").removeClass("reveal");
    $(".wp-block-group").find(".wp-block-heading").removeClass("reveal");
    $(".wp-block-group").find(".wp-block-group").removeClass("reveal");
    $(".taxonomy-hero").removeClass("reveal");
    $(".img-full.heroh").removeClass("reveal");
    $(".no-reveal").removeClass("reveal");
    this.scrolling();
    $(window).scroll(this.scrolling);
  },
  scrolling: function () {
    var reveals = document.querySelectorAll(".reveal");
    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var pad = window.innerWidth < 1025 ? 80 : 150;
      var elementVisible = pad;
      if (elementTop < windowHeight) {
        reveals[i].classList.add("active");
      } else {
        reveals[i].classList.remove("active");
      }
    }
  },
};
